import { render, staticRenderFns } from "./collegeDetails.vue?vue&type=template&id=63d83074&scoped=true&"
import script from "./collegeDetails.vue?vue&type=script&lang=js&"
export * from "./collegeDetails.vue?vue&type=script&lang=js&"
import style0 from "./collegeDetails.vue?vue&type=style&index=0&id=63d83074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d83074",
  null
  
)

export default component.exports